import { render, staticRenderFns } from "./LoadSearchQuery.vue?vue&type=template&id=b70bbcde&"
import script from "./LoadSearchQuery.vue?vue&type=script&lang=js&"
export * from "./LoadSearchQuery.vue?vue&type=script&lang=js&"
import style0 from "./LoadSearchQuery.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports